import APIMapper from './APIMapper';
import PromoterController from "../../controllers/PromoterController";

class PromoterAPIMapper extends APIMapper {
  update(change) {
    const { item, onSuccess, onError } = change;

    return PromoterController.putPromoter(item.nextValue)
      .then(onSuccess)
      .catch(onError);
  }

  delete(change) {
    const { item, onSuccess, onError } = change;

    return PromoterController.deletePromoter(item.prevValue)
      .then(onSuccess)
      .catch(onError);
  }
}

export default new PromoterAPIMapper();
